import { IntlShape } from 'react-intl';
import { musicServicesByMusicAPIID } from 'fym-shared/src/music-services/allMusicServices';
import {
  catalogDistributorServices,
  distributorNames,
  ServiceConnectionStatus,
} from 'fym-shared/src/smartlinks/catalog';
import { ServiceConnection } from '../../../../redux/api/fymAPI.types';
import { catalogServiceCardCopy } from '../catalogServiceCards';

/** True for a distributor card (DistroKid, TuneCore, …), false for a music service. */
export function isDistributor(integrationType: string): boolean {
  return catalogDistributorServices.includes(integrationType);
}

/**
 * The name a card, a modal and a confirm show: the programme name of a music
 * service ("Apple Music for Artists"), or the brand name of a distributor.
 */
export function catalogServiceName(intl: IntlShape, integrationType: string): string {
  const copy = catalogServiceCardCopy[integrationType];
  if (copy !== undefined) {
    return intl.formatMessage(copy.programName);
  }
  return distributorNames[integrationType] ?? musicServicesByMusicAPIID[integrationType]?.name ?? integrationType;
}

/** A `requested` row (or an old stub `pending` one) is a place on the list. */
export function isOnEarlyAccessList(connection: ServiceConnection): boolean {
  return (
    connection.status === ServiceConnectionStatus.requested || connection.status === ServiceConnectionStatus.pending
  );
}
